// src/components/BrandedLoader.jsx
//
// Pulsing CARO logo used in place of a bare CircularProgress for
// whole-page / whole-card loading states. Falls back to a spinner if
// the logo asset fails.
//
// Usage:
//   <BrandedLoader label="Loading alarms…" />
//   <BrandedLoader size="small" />       // inline

import React, { useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const SIZES = {
  small: 24,
  medium: 56,
  large: 96,
};

const BrandedLoader = ({
  label,
  size = 'medium',
  color = 'primary',
  sx,
}) => {
  const [failed, setFailed] = useState(false);
  const px = SIZES[size] ?? SIZES.medium;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1.5,
        py: size === 'small' ? 0 : 3,
        ...sx,
      }}
    >
      {failed ? (
        <CircularProgress size={px * 0.6} color={color} />
      ) : (
        <Box
          component="img"
          src="/logo/logo-full.png"
          alt=""
          onError={() => setFailed(true)}
          sx={{
            height: px,
            width: 'auto',
            opacity: 0.85,
            animation: 'brandedLoaderPulse 1.6s ease-in-out infinite',
            '@keyframes brandedLoaderPulse': {
              '0%, 100%': { opacity: 0.55, transform: 'scale(0.98)' },
              '50%': { opacity: 1, transform: 'scale(1.03)' },
            },
          }}
        />
      )}
      {label && (
        <Typography variant="body2" color="text.secondary">
          {label}
        </Typography>
      )}
    </Box>
  );
};

export default BrandedLoader;
